<template lang="pug">
  div
    label(class='u-mb1 u-block' v-if='label', :class='labelClass') {{label}}

    div(:class='wrapperClass')
      textarea(v-if="type === 'textarea'",
        :value='value', ref='input', :placeholder='placeholder'
        @input='updateValue($event.target.value)', :class="{inputClass, 'u-border-warning' : message}", :rows='rows')

      input(v-if="type !== 'textarea' && !mask"
        :value='value', :type='type', :name='name', ref='input', :placeholder='placeholder', :min='min' @blur='formatValue'
        @input='updateValue($event.target.value)', :class="{inputClass, 'u-border-warning' : message}" class='u-block')

      input(v-if="type !== 'textarea' && mask" v-mask='mask'
        :value='value', :type='type', :name='name', ref='input', :placeholder='placeholder', :min='min' @blur='formatValue'
        @input='updateValue($event.target.value)', :class="{inputClass, 'u-border-warning' : message}" class='u-block')
      i(class='u-icon' v-if='icon') {{icon}}

    p(v-html='info' v-if='info' class='u-color-text u-fz-h6 u-mt1 u-mb0' style='font-size:12px;user-select: none;')
    span(v-if='message' class='u-fz-h6 u-pt1 u-pl1 u-block', :class='errorClass') {{message}}
</template>

<script>
  import Validator from 'validatorjs'

  export default {
    props: {
      inputClass: String,
      wrapperClass: String,
      mask: {
        type: String,
        default: ''
      },
      info: String,
      label: String,
      labelClass: String,
      name: String,
      placeholder: String,
      validation: Boolean,
      value: [String, Number],
      icon: String,
      min: String,
      clear: Boolean,
      errorBorder: {
        type: String,
        default: 'u-border-error'
      },
      errorClass: {
        type: String,
        default: 'u-color-error'
      },
      type: {
        type: String,
        default: 'text'
      },
      rule: {
        type: String,
        default: 'required'
      },
      messageColor: {
        type: String,
        default: 'error'
      },
      rows: {
        type: String,
        default: '4'
      }
    },

    data () {
      return {
        message: '',
        validated: false
      }
    },

    methods: {
      updateValue (value) {
        if (this.type === 'number') {
          this.$emit('input', parseInt(value, 10))
        } else {
          this.$emit('input', value)
        }

        this.validate()
      },

      validate () {
        if (this.rule) {
          let validate = new Validator({value: this.$refs.input.value ? this.$refs.input.value : this.value}, {value: this.rule})
          this.validated = validate.passes()
          this.message = validate.errors.first('value')
        }
      },

      formatValue () {
        if (this.type === 'number' && this.value < this.min && this.value === !null) {
          this.$emit('input', this.min)
        }
      }
    },

    watch: {
      validation (val, oldVal) {
        this.validate()
      },
      clear (val) {
        this.message = ''
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/app/shared/components/InputValidate.vue